import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { DatosPersonales } from 'src/app/global/interfaces/datos-personales';
import { Nacionalidad } from 'src/app/global/interfaces/nacionalidad';
import { datosPersonales } from 'src/app/messages/step-2-messages';
import { correoValidator } from 'src/app/view-model/validators/correo.validator';

import { MatExpansionPanel } from '@angular/material';
import * as _ from 'lodash';
import { DatosPersonalesRequest } from 'src/app/global/interfaces/datos-personales-request';
import { ProductosProvider } from 'src/app/global/providers/services/productos/productos.provider';
import { DatosPersonalesService } from 'src/app/global/services/datos-personales.service';
import { FlujosPaso2Service } from 'src/app/global/services/flujos-paso-2.service';
import { InputErrorService } from 'src/app/global/services/input-errors.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { DialogServiceProvider } from 'src/app/view-model/providers/services/dialog/dialog.provider';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { lengthValidator } from 'src/app/view-model/validators/max-length.validator';

@Component({
  selector: 'app-datos-personales',
  templateUrl: './datos-personales.component.html',
  styleUrls: ['./datos-personales.component.scss'],
  providers: [DialogServiceProvider, ProductosProvider]
})
export class DatosPersonalesComponent {

  @ViewChild(MatExpansionPanel, { static: false }) matExpansion: MatExpansionPanel;

  isDatosPrecargados = false;
  datosPersonalesResponse: DatosPersonales;
  nacionalidades: Nacionalidad[] = [];
  edicion = true;
  processing = false;
  private clickTimeout = null;

  // control de panles
  ready = false;
  loading = false;
  dialog2doPlano = false;

  @Input() showInfoMessage = false;

  @Input() showCantidadCampos = true;

  @Output() paso1Ok: EventEmitter<any> = new EventEmitter();

  get flujo() { return this.flujosPaso2Serv.datosPersonales; }

  constructor(private datosPersonalesService: DatosPersonalesService,
              private dialogProv: DialogServiceProvider,
              private productosProv: ProductosProvider,
              private marketplaceRedirectService: MarketplaceRedirectService,
              private storage: LocalStorageService,
              private productService: vmProductosService,
              private tagM: TagManagerService,
              private flujosPaso2Serv: FlujosPaso2Service,
              private inputErrorService: InputErrorService) {

  }

  public datosPersonalesForm: FormGroup = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    primerApellido: new FormControl('', [Validators.required]),
    segundoApellido: new FormControl('', [Validators.nullValidator]),
    nacionalidad: new FormControl('0', [Validators.required, Validators.min(1)]),
    correoElectronico: new FormControl('', [Validators.required,
      correoValidator

    ]),
    telefono: new FormControl('', [Validators.required, lengthValidator(9, 9), Validators.pattern('^[1-9][0-9]*')])
    /*  codigoVerificacion: new FormControl('', [Validators.required]), */
  });

  public mensajeErrorDatosPersonales = datosPersonales;
  formChanged = false;

  // ngOnInit(): void {
  //   // subcribirme a lo que el input esta escribiendo y colocar esta validacion
  // }

  get calculaCantidadALlenar() {
    let cantidad = 2;
    const nombre = _.get(this.datosPersonalesResponse, 'nombre', null);
    const apellido1 = _.get(this.datosPersonalesResponse, 'apellidoPaterno', null);
    const nacionalidad = _.get(this.datosPersonalesResponse, 'idNacionalidad', null);
    cantidad += nombre === '' ? 1 : 0;
    cantidad += apellido1  === '' ? 1 : 0;
    cantidad += nacionalidad !== 47 ? 1 : 0;
    if (!this.isDatosPrecargados) {
      cantidad = 5;
    }
    return cantidad;
  }

  init(): void {
    this.validaEdicion();
  }

  error(error, callback: Function) {
    // this.showErrorDialog(error.statusText, error.message, () => callback());
    if (error.error.indicador === 'PROCESO_SEGUNDO_PLANO') {
      // this.dialogProv.openProcesoSegundoPlano().afterClosed().subscribe( () => {
      //   this.marketplaceRedirectService.redirectPortalPublico();
      // });
      this.dialogProv.openEnSegundoProcesoDialog();
    } else {
      this.showErrorDialog(error.statusText, error.message, () => callback());
    }
  }

  functionNr1(): void {
    setTimeout (() => {
      this.getDatosPersonales();
      }, 5000);
  }

  getNacionalidades(): void {
    const fnSuccess = (nacionalidades: Nacionalidad[]) => {
      this.nacionalidades = nacionalidades;
      this.getDatosPersonales();
    };

    const fnFailure = (error) => {
      console.error(error);
      this.error(error, () => this.getNacionalidades());
      this.tagM.logError('Paso 2', error.statusText, error.message);
    };

    this.datosPersonalesService.getNacionalidades().subscribe(fnSuccess, fnFailure);
  }

  validaEdicion() {
    // const fnSuccess = (edicion: GeneralResponse<boolean>) => {
    //   this.edicion = edicion.data;
    //   this.getNacionalidades();
    // };

    // const fnFailure = (error) => {
    //   console.error(error);

    //   this.error(error, () => this.validaEdicion());
    // };
    this.edicion = true;
    this.getNacionalidades();
    // this.datosPersonalesService.validaEdicion().subscribe(fnSuccess, fnFailure);
  }

  getDatosPersonales(): void {
    const fnSuccess = (resp) => {
      if (resp != null) {
        if ( _.get(resp, 'indicador', '') === 'PROCESO_SEGUNDO_PLANO') {
          this.dialogProv.openEnSegundoProcesoDialog();
          this.dialog2doPlano = true;
          this.functionNr1();
        } else {
          if ( this.dialog2doPlano == true) {
            this.dialogProv.closeProcesoSegundoPlanoDialog();
            this.dialog2doPlano = false;
          }

          this.isDatosPrecargados = true;
          this.datosPersonalesResponse = resp as DatosPersonales;
          this.datosPersonalesForm.get('nombre').setValue(this.datosPersonalesResponse.nombre.nombres);
          this.datosPersonalesForm.get('primerApellido').setValue(this.datosPersonalesResponse.nombre.apellidoPaterno);
          this.datosPersonalesForm.get('segundoApellido').setValue(this.datosPersonalesResponse.nombre.apellidoMaterno);
          if (this.datosPersonalesResponse.idNacionalidad) {
            this.datosPersonalesForm.get('nacionalidad').setValue(this.datosPersonalesResponse.idNacionalidad);
          } else {
            this.datosPersonalesForm.get('nacionalidad').setValue(0);
          }
          this.datosPersonalesForm.get('correoElectronico').setValue(this.datosPersonalesResponse.correo);
          this.datosPersonalesForm.get('telefono').setValue(this.datosPersonalesResponse.telefono);
          if (this.datosPersonalesForm.valid) {
            const datos: DatosPersonalesRequest = {
              nombres: this.datosPersonalesResponse.nombre,
              idNacionalidad: this.datosPersonalesResponse.idNacionalidad,
              correo: this.datosPersonalesResponse.correo,
              telefono: this.datosPersonalesResponse.telefono
            };
            this.storage.setPaso2({ datosPersonales: datos });
            this.flujosPaso2Serv.datosPersonales.ok = true;
            this.flujosPaso2Serv.datosComercio.bloqueado = false;
            this.flujosPaso2Serv.datosComercio.cargando = true;
            this.paso1Ok.emit();
          } else {
            this.matExpansion.open();
            this.dialogProv.closeProcesoSegundoPlanoDialog();
          }

        }

      } else {
        this.isDatosPrecargados = false;
        this.matExpansion.open();
        this.dialogProv.closeProcesoSegundoPlanoDialog();
      }

      this.flujosPaso2Serv.datosPersonales.mostrar = true;
      this.flujosPaso2Serv.datosPersonales.cargando = false;

    };

    const fnFailure = error => {
      // this.showErrorDialog(error.statusText, error.message, () => this.getDatosPersonales());
      this.error(error, () => this.getDatosPersonales());
      this.tagM.logError('Paso 2', error.statusText, error.message);
      this.functionNr1();
    };

    // Obtener el rut desde el paso 1 (puede ser por un @Input)
    this.datosPersonalesService.getDatosPersonales().subscribe(fnSuccess, fnFailure);
  }

  Continuar($event: any) {
    $event.stopPropagation(); // Para que no se propague a los componentes inferiores
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.registraDatos();
     }, 100);
    }

  }

  guardar(): void {
    this.registraDatos();
  }

  registraSeleccionProducto() {
    try {
      this.productService.registraSeleccionProductoActual().toPromise();
    } catch (e) {
      console.error('SELECCION PRODUCTO:', e);
    }
  }

  async registraDatos() {

    this.loading = true;

    const datos: DatosPersonalesRequest = {
      nombres: {
        nombres: this.datosPersonalesForm.get('nombre').value,
        apellidoPaterno: this.datosPersonalesForm.get('primerApellido').value,
        apellidoMaterno: this.datosPersonalesForm.get('segundoApellido').value
      },
      idNacionalidad: Number(this.datosPersonalesForm.get('nacionalidad').value),
      correo: this.datosPersonalesForm.get('correoElectronico').value,
      telefono: Number(this.datosPersonalesForm.get('telefono').value)
    };

    const fnSuccess = async (resp) => {
      // Persona registrada
      this.registraSeleccionProducto();
      if (!this.flujosPaso2Serv.datosComercio.ok) {
        if (!this.isDatosPrecargados) {
          console.log('Llamada a datalayer OK');
        }
        this.storage.setPaso2({ datosPersonales: datos });
        this.ready = true;
        this.flujosPaso2Serv.datosPersonales.ok = true;
        this.flujosPaso2Serv.datosComercio.cargando = true;
        this.flujosPaso2Serv.datosComercio.bloqueado = false;
        this.paso1Ok.emit();
        this.tagM.logDL_datosPersonales();
      }
      this.matExpansion.close();
      this.loading = false;
      this.processing = false;
    };

    const fnFailure = (error) => {
      console.error(error);
      this.loading = false;
      this.error(error, () => this.registraDatos());
      this.tagM.logError('Paso 2', error.statusText, error.message);
      this.processing = false;
    };

    this.datosPersonalesService.registraDatosPersonales(datos).subscribe(fnSuccess, fnFailure);

  }

  showErrorDialog(title: string, message: string, callback: Function) {
    this.dialogProv.openErrorDialog(title, message).afterClosed()
      .subscribe((data) => {
        callback();
      });
  }

  checkInput(campo: string) {
    this.inputErrorService.validarError('P2', this.datosPersonalesForm.get(campo));
  }

}
